import * as React from 'react';
import {Link} from "react-router-dom";
import Avatar from "@mui/material/Avatar";

export default function SocialmediaIcon(props) {
    const smapp = props?.smapp;
    const iconUrl = `/assets/images/socialmedia/${smapp?.iconUrl}`;
    const socialMediaUrl = props?.socialMediaUrl;
  return (
      (socialMediaUrl? (
          <Link to={socialMediaUrl} target={'_blank'}>
              <Avatar
                  src={iconUrl}
                  sx={{mb:1, width: '25px', height: '25px'}}
                  // href={iconUrl}
                  slotProps={{
                      img: {
                          loading: "lazy",
                      },
                  }}
              />
          </Link>
          ):(<></>)
      )
  );
};
